export default __webpack_public_path__ + "static/media/tlok.6448b975.svg";